import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

/**
 * The one Flow Editor upsell dialog — shown wherever a gated user tries to
 * enter the editor (New Automation button, Build with AI prompt box).
 */
export default function showFlowEditorUpgrade() {
    Modal.confirm({
        title: 'Upgrade to unlock the Flow Editor',
        content:
            'The Flow Editor — visual flows, templates and the AI flow builder — is available on the Trendsetter and Multi-Account plans.',
        icon: <ExclamationCircleFilled style={{ color: '#6366f1' }} />,
        okText: 'See plans',
        cancelText: 'Not now',
        // Hard navigation on purpose — the sider only reads ?show_plans=true
        // on mount, so a soft route change would not open the plan modal.
        onOk: () => { window.location.href = '/?show_plans=true'; },
    });
}
